import { Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

import { ReorderLocationsFacade } from '@recruitee/locations';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class ReorderLocationsRequisitionFacade extends ReorderLocationsFacade {
  constructor(private requisitionFormManager: RequisitionFormManagerService) {
    super();
  }

  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
